<template>
  <div class="recent-education--section">
    <template v-for="(item, index) in recent">
      <div class="row" :key="index" style="margin-bottom:15px;">
        <v-input :value="recent[index].degree" @input="value => recent[index].degree = value" :name="`education.recent.${index}.degree`" label="HIGHEST DEGREE OBTAINED" :required="index === 0" addclass="input-sm-margin"></v-input>
        <v-input :value="recent[index].schoolname" @input="value => recent[index].schoolname = value" :name="`education.recent.${index}.schoolname`" label="NAME OF SCHOOL OR UNIVERSITY" :required="index === 0" addclass="input-sm-margin"></v-input>
      </div>
    </template>

    <div class="row" v-if="this.recent.length < 3">
      <div class="col-12">
        <button class="btn-submit" type="button" @click.prevent="addEducation" style="width:auto;">
          <b>+</b> Add position
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VInput from '../fields/VInput'

const education = {
  degree: '',
  schoolname: ''
}

export default {
  inject: [
    'errors'
  ],
  components: {
    VInput
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      recent: [{ ...education }]
    }
  },
  methods: {
    addEducation () {
      this.recent.push({ ...education })
    }
  },
  watch: {
    recent: {
      deep: true,
      immediate: true,
      handler: function (recent) {
        this.$emit('input', recent)
      }
    }
  }
}
</script>
